import * as React from 'react';
import { Container, TituloSecao } from './styles';
import Grid from '../../componentes/Grid';
import userContext from '../../Context/UserContext';
import { useContext } from 'react';

const MaisVendidos: React.FC = () => {
  const currentlyUser = useContext(userContext);
  const {Codcliente, Codempresacli} = currentlyUser.user;

  return (
    <Container>
      <TituloSecao>
        Mais Vendidos
      </TituloSecao>
        <Grid Titulo={"Mais Vendidos"} MaisVendidos={1} Codcliente={Codcliente} Codempresacli={Codempresacli}/>
    </Container>
  )
};

export default MaisVendidos;
